var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { BridgeType, PresaleContractType, } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { Contract, ethers } from 'ethers';
import { useContext, useEffect, useState } from 'react';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { legacyContractAbi, legacyContractAddress } from '../../data/bridge/legacy';
import { premiumContractAbi, premiumContractAddress } from '../../data/bridge/premium';
import { standardContractAbi, standardContractAddress } from '../../data/bridge/standard';
import { appEnv } from '../../env';
import { WalletConnectionType } from '../../types/blockchain';
import { DialogType } from '../../types/dialogs';
import { ethValidChainId, polygonValidChainId } from '../../utils/blockchain';
import { useImxActions } from '../imx/use-imx-actions';
export var BORED_BOX_COLLECTION_ADDRESS = appEnv.isLive
    ? '0x8e3c7e22566983e1ede005762a6afab6bdf28277'
    : appEnv.blockchain.collectionAddress;
export function useNft(bridgeType, contractType, metamaskReady) {
    var t = useI18n().t;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var setImxLoading = useContext(LoadingContext).setImxLoading;
    var _a = useContext(UserContext), user = _a.user, reconnect = _a.reconnectUser;
    var _b = useState([]), packs = _b[0], setPacks = _b[1];
    var _c = useState([]), nfts = _c[0], setNft = _c[1];
    var _d = useState(null), errorMessage = _d[0], setErrorMessage = _d[1];
    var _e = useState(false), initialized = _e[0], setInitalized = _e[1];
    var _f = useState(undefined), confirmOnClose = _f[0], setConfirmOnClose = _f[1];
    var imxActions = useImxActions();
    useEffect(function () {
        function onBeforeUnload(event) {
            event.preventDefault();
            return t('bridge.confirm-close');
        }
        if (confirmOnClose === true) {
            window.addEventListener('onbeforeunload', onBeforeUnload);
        }
        else if (confirmOnClose === false) {
            window.removeEventListener('onbeforeunload', onBeforeUnload);
        }
    }, [confirmOnClose]);
    useEffect(function () {
        if (window.ethereum && metamaskReady) {
            onChooseContract();
        }
        getPacks();
    }, [metamaskReady]);
    function getPacks() {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, gqlSdk.BridgeFindManyBridgeItem()];
                    case 1:
                        result = _a.sent();
                        setPacks(result ? result.bridgeFindManyBridgeItem : []);
                        return [2 /*return*/];
                }
            });
        });
    }
    function onChooseContract() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getNFTs()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function getNFTs() {
        return __awaiter(this, void 0, void 0, function () {
            var myNFTs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!bridgeType)
                            return [2 /*return*/];
                        return [4 /*yield*/, gqlSdk.BridgeGetNftList({
                                input: { bridgeType: bridgeType, contractType: bridgeType === BridgeType.BORED_BOX ? undefined : contractType },
                            })];
                    case 1:
                        myNFTs = _a.sent();
                        setNft(myNFTs.bridgeGetNftList);
                        setInitalized(true);
                        return [2 /*return*/];
                }
            });
        });
    }
    function showConfirmBridgeDialog(tokenId) {
        setDialogProps({
            common: {
                title: t('bridge.confirm-dialog.title'),
                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                actions: [{ text: t('common.link-wallet'), highlighted: true, action: function () { return handleBridge(tokenId); } }],
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('bridge.confirm-dialog.message', { tokenId: tokenId }),
            },
        });
    }
    function handleBridge(tokenId) {
        switch (bridgeType) {
            case BridgeType.POLYGON_PRESALE: {
                return handleBridgePolygonPresale(tokenId);
            }
            case BridgeType.BORED_BOX: {
                return handleBridgeBoredBox(tokenId);
            }
            default: {
                console.log("Invalid bridgeType: ".concat(bridgeType));
            }
        }
        return Promise.resolve(false);
    }
    function handleBridgePolygonPresale(tokenId) {
        return __awaiter(this, void 0, Promise, function () {
            var chainIdReq, error, provider, signer, contractAddress, contractAbi, instance, burnTransaction, feeData, gasPrice, _a, burnReceipt, err_1, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!bridgeType)
                            return [2 /*return*/, false];
                        setImxLoading(true);
                        if (!user || !user.polygonWalletId) {
                            setImxLoading(false);
                            return [2 /*return*/, false];
                        }
                        if (!window.ethereum) {
                            setErrorMessage(t('error.metamask-not-installed'));
                            setImxLoading(false);
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, window.ethereum.request({ method: 'eth_chainId' })];
                    case 1:
                        chainIdReq = _b.sent();
                        if (chainIdReq !== polygonValidChainId) {
                            setErrorMessage(t('error.incorrect-network-polygon'));
                            setImxLoading(false);
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, gqlSdk.BridgeSaveTokenToBurn({
                                input: { bridgeType: bridgeType, tokenId: tokenId, contractType: contractType },
                            })];
                    case 2:
                        _b.sent();
                        provider = new ethers.BrowserProvider(window.ethereum);
                        return [4 /*yield*/, provider.getSigner(user.polygonWalletId)];
                    case 3:
                        signer = _b.sent();
                        switch (contractType) {
                            case PresaleContractType.STANDARD: {
                                contractAddress = standardContractAddress;
                                contractAbi = standardContractAbi;
                                break;
                            }
                            case PresaleContractType.PREMIUM: {
                                contractAddress = premiumContractAddress;
                                contractAbi = premiumContractAbi;
                                break;
                            }
                            case PresaleContractType.LEGACY: {
                                contractAddress = legacyContractAddress;
                                contractAbi = legacyContractAbi;
                                break;
                            }
                            default: {
                                setErrorMessage(t('error.incorrect-contract-type'));
                                setImxLoading(false);
                                return [2 /*return*/, false];
                            }
                        }
                        instance = new Contract(contractAddress, contractAbi, signer);
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 19, , 21]);
                        burnTransaction = void 0;
                        if (!(contractType === PresaleContractType.LEGACY)) return [3 /*break*/, 7];
                        return [4 /*yield*/, provider.getFeeData()];
                    case 5:
                        feeData = _b.sent();
                        if (!feeData || !feeData.gasPrice) {
                            setErrorMessage(t('error.cannot-determine-gas-price'));
                            setImxLoading(false);
                            return [2 /*return*/, false];
                        }
                        gasPrice = (feeData.gasPrice * BigInt(150)) / BigInt(100);
                        return [4 /*yield*/, instance['safeTransferFrom(address,address,uint256,uint256,bytes)'](user.polygonWalletId, '0x000000000000000000000000000000000000dEaD', tokenId, 1, '0x', { gasPrice: gasPrice })];
                    case 6:
                        burnTransaction = _b.sent();
                        return [3 /*break*/, 12];
                    case 7:
                        if (!(contractType === PresaleContractType.PREMIUM)) return [3 /*break*/, 9];
                        return [4 /*yield*/, instance.burn(tokenId, 1)];
                    case 8:
                        _a = _b.sent();
                        return [3 /*break*/, 11];
                    case 9: return [4 /*yield*/, instance.burn(user.polygonWalletId, tokenId, 1)];
                    case 10:
                        _a = _b.sent();
                        _b.label = 11;
                    case 11:
                        burnTransaction = _a;
                        _b.label = 12;
                    case 12:
                        console.log(burnTransaction);
                        return [4 /*yield*/, gqlSdk.BridgeSetBurnStatusPending({
                                input: { bridgeType: bridgeType, contractType: contractType, tokenId: tokenId },
                            })];
                    case 13:
                        _b.sent();
                        return [4 /*yield*/, burnTransaction.wait()];
                    case 14:
                        burnReceipt = _b.sent();
                        console.log(burnReceipt);
                        _b.label = 15;
                    case 15:
                        _b.trys.push([15, 17, , 18]);
                        return [4 /*yield*/, gqlSdk.BridgeSaveTransactionId({
                                input: {
                                    transactionId: burnReceipt.transactionHash,
                                    contractType: contractType,
                                    tokenId: tokenId,
                                    bridgeType: bridgeType,
                                },
                            })];
                    case 16:
                        _b.sent();
                        return [3 /*break*/, 18];
                    case 17:
                        err_1 = _b.sent();
                        error = t('error.generic');
                        console.log(err_1);
                        return [3 /*break*/, 18];
                    case 18: return [3 /*break*/, 21];
                    case 19:
                        err_2 = _b.sent();
                        error = t('error.generic');
                        console.log(err_2);
                        return [4 /*yield*/, gqlSdk.BridgeSetBurnStatusFailed({
                                input: { contractType: contractType, tokenId: tokenId, bridgeType: bridgeType },
                            })];
                    case 20:
                        _b.sent();
                        return [3 /*break*/, 21];
                    case 21: return [4 /*yield*/, reconnect()];
                    case 22:
                        _b.sent();
                        return [4 /*yield*/, getNFTs()];
                    case 23:
                        _b.sent();
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.success'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('bridge.success-message'),
                            },
                        });
                        setImxLoading(false);
                        setConfirmOnClose(true);
                        return [2 /*return*/, true];
                }
            });
        });
    }
    function handleBridgeBoredBox(tokenId) {
        return __awaiter(this, void 0, Promise, function () {
            var error, chainIdReq, isBurned, asset, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!bridgeType)
                            return [2 /*return*/, false];
                        setImxLoading(true);
                        if (!user || !user.polygonWalletId) {
                            setImxLoading(false);
                            return [2 /*return*/, false];
                        }
                        if (!window.ethereum) {
                            setErrorMessage(t('error.metamask-not-installed'));
                            setImxLoading(false);
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, window.ethereum.request({ method: 'eth_chainId' })];
                    case 1:
                        chainIdReq = _a.sent();
                        if (chainIdReq !== ethValidChainId) {
                            setErrorMessage(t('error.incorrect-network-eth'));
                            setImxLoading(false);
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, gqlSdk.BridgeSaveTokenToBurn({
                                input: { bridgeType: bridgeType, tokenId: tokenId },
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 14, , 16]);
                        return [4 /*yield*/, imxActions.transferERC721({
                                walletFrom: { address: user.polygonWalletId, connectionType: WalletConnectionType.METAMASK },
                                tokenIds: [tokenId],
                                toAddress: '0x0000000000000000000000000000000000000000',
                                tokenAddress: BORED_BOX_COLLECTION_ADDRESS,
                            })];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, gqlSdk.BridgeSetBurnStatusPending({
                                input: { bridgeType: bridgeType, tokenId: tokenId },
                            })];
                    case 5:
                        _a.sent();
                        isBurned = false;
                        _a.label = 6;
                    case 6: return [4 /*yield*/, imxActions.imxClient.getAsset({ tokenId: tokenId, tokenAddress: BORED_BOX_COLLECTION_ADDRESS })];
                    case 7:
                        asset = _a.sent();
                        if (!(asset && asset.user === '0x0000000000000000000000000000000000000000')) return [3 /*break*/, 8];
                        isBurned = true;
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 2000); })];
                    case 9:
                        _a.sent();
                        _a.label = 10;
                    case 10:
                        if (!isBurned) return [3 /*break*/, 6];
                        _a.label = 11;
                    case 11: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 10000); })];
                    case 12:
                        _a.sent();
                        return [4 /*yield*/, gqlSdk.BridgeSetBurnStatusBridged({
                                input: { bridgeType: bridgeType, tokenId: tokenId },
                            })];
                    case 13:
                        _a.sent();
                        return [3 /*break*/, 16];
                    case 14:
                        err_3 = _a.sent();
                        error = t('error.generic');
                        console.log(err_3);
                        return [4 /*yield*/, gqlSdk.BridgeSetBurnStatusFailed({
                                input: { tokenId: tokenId, bridgeType: bridgeType },
                            })];
                    case 15:
                        _a.sent();
                        return [3 /*break*/, 16];
                    case 16:
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.success'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('bridge.success-message'),
                            },
                        });
                        return [4 /*yield*/, reconnect()];
                    case 17:
                        _a.sent();
                        return [4 /*yield*/, getNFTs()];
                    case 18:
                        _a.sent();
                        setImxLoading(false);
                        setConfirmOnClose(true);
                        return [2 /*return*/, true];
                }
            });
        });
    }
    return {
        packs: packs,
        nfts: nfts,
        errorMessage: errorMessage,
        initialized: initialized,
        confirmOnClose: confirmOnClose,
        onChooseContract: onChooseContract,
        showConfirmBridgeDialog: showConfirmBridgeDialog,
        setErrorMessage: setErrorMessage,
    };
}
